import React from 'react';
import PropTypes from 'prop-types';
import Social from './Social';
import { SOCIALS_MAP } from '../../consts';

const Socials = ({
  parent,
  order = ['instagram', 'podcast', 'pinterest', 'facebook', 'youtube'],
  prependedChildren,
  appendedChildren,
}) => {
  const renderedSocials = order.map(id => SOCIALS_MAP[id]).map((social, i) => {
    const { className, href } = social;

    let link = href;

    if (className.includes('podcast') && (parent !== null)) {
      const parental = parent.toLowerCase();
      if (parental === 'header') {
        link = `${href}&at=1010lLxU&ct=website_header_lfbc`;
      } else if (parental === 'footer') {
        link = `${href}&at=1010lLxU&ct=website_footer_lfbc`;
      } else if (parental === 'nav') {
        link = `${href}&at=1010lLxU&ct=website_side_lfbc`;
      }
    }

    return (
      <Social
        key={i}
        className={className}
        href={link}
        parent={parent} />
    );
  });

  return (
    <ul className="socials">
      {prependedChildren}
      {renderedSocials}
      {appendedChildren}
    </ul>
  );
};

Socials.propTypes = {
  parent: PropTypes.string,
  order: PropTypes.array,
  prependedChildren: PropTypes.node,
  appendedChildren: PropTypes.node,
};

export default Socials;
